import React, { useEffect, useState } from "react";
// import { FundTransferCreate, FundTransferList } from "../../../api/FundService";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { closeModal, ToastMain ,SweetAlertShow} from "../master/Master";
import HostelHeader from "./HostelHeader";
import Nav from "../master/NavBar";
import { BankList, BankMoneyTransfer, BankTransferList } from "../../api/BankService";
import { imgBaseUrl } from "../../api/api";

export default function HostelFundTransfer() {
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [transfers, setTransfers] = useState([]);
  const navigate = useNavigate();
  const [type, setType] = useState('');
  const [selectedAccount, setSelectedAccount] = useState("");
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [imgModal, setImgModal] = useState({ show: false, src: "" });
  const [page , setPage]=useState(1)

  const exportToExcel = () => {
    if (!transfers?.data?.length) return;

    // Map the data into plain objects
    const exportData = transfers?.data?.map((item) => ({
      "From Bank": item?.from_bank?.owner_name + " (" + item.from_bank?.account_no + ")",
      "To Bank": item?.to_bank?.owner_name + " (" + item.to_bank?.account_no + ")",
      Amount: item.amount,
      "Transfer Date": item?.transfer_date,
      Description: item?.description || "-",
      // Image: item.img ? `${imgBaseUrl}${item.img}` : "-",
    }));

    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transfers");

    // Generate buffer
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    // Save file
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Bank_Transfers.xlsx");
  };

  const getBanks = async () => {
    setLoading(true);
    try {
      const response = await BankList();
      if (response?.data?.status) {
        setBanks(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  const getTransfers = async () => {
    let addUrl = `&start_date=${start}&end_date=${end}&account_no=${selectedAccount}&page=${page}`
    setLoading(true);
    try {
      const response = await BankTransferList(addUrl);
      if (response?.data?.status) {
        setTransfers(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message  ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBanks();

  }, []);


  useEffect(() => {
    getTransfers();
  }, [start, end, selectedAccount,page])
  const handleTransferSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await BankMoneyTransfer(formData);
      if (response?.data?.status) {
        closeModal("FundTransferModal");
        e.target.reset();
        // ToastMain.fire({
        //   icon: "success",
        //   title: response?.data?.message || "Transfer Successful",
        // });
        SweetAlertShow('success','Successfully',response?.data?.message)
        e.target.reset();
        getTransfers();
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <HostelHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 className="text-primary"> Banks Transactions</h4>
                      <div className="d-flex justify-content-center gap-2">
                        {/* New Transfer */}
                        <button
                          className="btn btn-sm btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#FundTransferModal"
                          style={{ display: "flex", alignItems: "center", gap: "4px" }}
                        >
                          <i className="bi bi-plus-lg" style={{ fontSize: "14px" }}></i>
                          New Transfer
                        </button>

                        {/* Export to Excel */}
                        <button
                          className="btn btn-sm btn-success"
                          onClick={exportToExcel}
                          style={{ display: "flex", alignItems: "center", gap: "4px" }}
                        >
                          <i className="bi bi-cloud-arrow-down" style={{ fontSize: "14px" }}></i>
                          Export
                        </button>

                        {/* Back */}
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={(e) => navigate(-1)}
                          style={{ display: "flex", alignItems: "center", gap: "4px" }}
                        >
                          <i className="bi bi-arrow-left" style={{ fontSize: "14px" }}></i>
                          Back
                        </button>
                      </div>

                    </div>

                    <div className=" row d-flex">
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline">
                          <input className="form-control" type="date" placeholder="Date" name="start_date" value={start} onChange={(e) => setStart(e.target.value)} />
                          <label htmlFor="">Start Date</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline">
                          <input className="form-control" type="date" placeholder="Date" name="end_date" value={end} onChange={(e) => setEnd(e.target.value)} />
                          <label htmlFor="">End Date</label>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline">
                          <select className="form-select" name="account_no" value={selectedAccount} onChange={(e) => setSelectedAccount(e.target.value)}>
                            <option>Select Banks</option>
                            {banks?.map((item, index) => (
                              <option key={item?.id} value={item?.id}>{item?.account_no}:({item?.owner_name})</option>
                            ))}
                          </select>
                          <label htmlFor="">Bank Accounts</label>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <div className="card mt-3">
                  <div className="card-body">

                    {/* Transfer Table */}
                    <div className="table-responsive">
                      <table className="table border table-bordered">
                        <thead className="table-primary text-center">
                          <tr>
                            <th>#</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Amount</th>
                            <th>Transfer Date</th>
                            <th>Image</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transfers?.data?.length > 0 ? (
                            transfers.data.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  {item.from_bank?.owner_name} <br />
                                  <small>({item.from_bank?.account_no})</small>
                                </td>
                                <td>
                                  {item.to_bank?.owner_name} <br />
                                  <small>({item.to_bank?.account_no})</small>
                                </td>
                                <td>₹ {item.amount}</td>
                                <td>{new Date(item.transfer_date).toLocaleDateString()}</td>
                                <td className="text-center">
                                  {item.img ? (
                                    <img
                                      src={`${imgBaseUrl}${item.img}`}
                                      alt="Proof"
                                      style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "5px", cursor: "pointer" }}
                                      onClick={() => setImgModal({ show: true, src: `${imgBaseUrl}${item.img}` })}
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>

                                <td>{item.description || "-"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center text-muted">
                                No transfers found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
<nav aria-label="Page navigation" className="mt-10">
                        <p>
                          Showing {transfers?.from} to {transfers?.to} of{" "}
                          {transfers?.total} entries
                        </p>
                        <ul className="pagination pagination-sm">
                          {transfers?.links?.map((btn, i) => (
                            <li
                              className={`page-item  ${btn?.active && "active"
                                }  ${btn?.url ? "" : "disabled"} `}
                            >
                              <button
                                className="page-link waves-effect"
                                onClick={() => {
                                  if (transfers?.links?.length === i + 1) {
                                    btn?.url &&
                                      setPage(transfers?.current_page + 1);
                                  } else if (i === 0) {
                                    btn?.url &&
                                      setPage(transfers?.current_page - 1);
                                  } else {
                                    setPage(btn.label);
                                  }
                                }}
                              >
                                {transfers?.links?.length == i + 1 ? (
                                  <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                ) : i == 0 ? (
                                  <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                ) : (
                                  btn?.label
                                )}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fund Transfer Modal */}
      <div
        className="modal fade"
        id="FundTransferModal"
        tabIndex={-1}
        aria-labelledby="FundTransferModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-label-primary">
              <h1 className="modal-title fs-5 mb-2" id="FundTransferModalLabel">
                New Fund Transfer
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <form onSubmit={handleTransferSubmit}>
              <div className="modal-body">
                <div className="row g-3">
                  {/* Transfer Type */}

                  {/* From Bank */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select"
                        name="from_bank"
                        required
                      >
                        <option value="">Select From Bank</option>
                        {banks.map((b, i) => (
                          <option key={i} value={b.id}>
                            {b.owner_name} ({b.account_no})
                          </option>
                        ))}
                      </select>
                      <label>From Bank</label>
                    </div>
                  </div>

                  {/* To Bank */}

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select"
                        name="to_bank"
                      >
                        <option value="">Select To Bank</option>
                        {banks.map((b, i) => (
                          <option key={i} value={b.id}>
                            {b.owner_name} ({b.account_no})
                          </option>
                        ))}
                      </select>
                      <label>To Bank</label>
                    </div>
                  </div>


                  {/* Amount */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="amount"
                        className="form-control"
                        placeholder="Enter Amount"
                        required
                        min="0"
                        step="any"
                      />
                      <label>Amount</label>
                    </div>
                  </div>

                  {/* Date */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="date"
                        name="transfer_date"
                        className="form-control"
                        required
                        defaultValue={new Date().toISOString().split("T")[0]}
                      />
                      <label>Date</label>
                    </div>
                  </div>

                  {/* Description */}
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline">
                      <input className="form-control" type="file" name="image" placeholder="Upload Img" />
                      <label>Upload Img</label>

                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        name="description"
                        className="form-control input-uppercase"
                        placeholder="Enter remarks or description"
                        rows="2"
                      ></textarea>
                      <label>Description</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Transfer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <div className={`modal fade ${imgModal.show ? "show d-block" : ""}`} tabIndex="1" role="dialog">
  <div className="modal-dialog modal-dialog-centered" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Proof Image</h5>
        <button type="button" className="btn-close" onClick={() => setImgModal({ show: false, src: "" })}></button>
      </div>
      <div className="modal-body text-center">
        {imgModal.src && <img src={imgModal.src} alt="Proof" style={{ width: "100%", height: "auto" }} />}
      </div>
    </div>
  </div>
  <div className="modal-backdrop fade show"></div>
</div> */}
    </>
  );
}
